import { useEffect, useState } from 'react';
const SCROLL_UP = 'up';
const SCROLL_DOWN = 'down';
const useScrollDirection = ({ initialDirection, thresholdPixels, off, scrollContext } = {}) => {
    const [scrollDir, setScrollDir] = useState(initialDirection || SCROLL_DOWN);
    useEffect(() => {
        const attachScrollTo = scrollContext !== null && scrollContext !== void 0 ? scrollContext : window;
        const threshold = thresholdPixels || 0;
        let lastScrollY = scrollContext ? scrollContext.scrollTop : window.pageYOffset;
        let ticking = false;
        const updateScrollDir = () => {
            const scrollY = scrollContext ? scrollContext.scrollTop : window.pageYOffset;
            if (Math.abs(scrollY - lastScrollY) < threshold) {
                // We haven't exceeded the threshold
                ticking = false;
                return;
            }
            setScrollDir(scrollY > lastScrollY ? SCROLL_DOWN : SCROLL_UP);
            lastScrollY = scrollY > 0 ? scrollY : 0;
            ticking = false;
        };
        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };
        /**
         * Bind the scroll handler if `off` is set to false.
         * If `off` is set to true reset the scroll direction.
         */
        !off ? attachScrollTo.addEventListener('scroll', onScroll) : setScrollDir(initialDirection || SCROLL_DOWN);
        return () => attachScrollTo.removeEventListener('scroll', onScroll);
    }, [initialDirection, thresholdPixels, off, scrollContext]);
    return scrollDir;
};
export default useScrollDirection;
